import React from 'react';
import { useTranslation } from 'react-i18next';

import { getTestingCoursePlaceholderData } from '@modules/testing/helpers';

import type {
    TestingCoursePlaceholderDataProps,
    TestingCoursePlaceholderPayload,
} from '@modules/testing/helpers';

type UseTestingPlaceholderDataOptions = Omit<TestingCoursePlaceholderPayload, 't'>;

const useTestingCoursePlaceholderData = (
    type: TestingCoursePlaceholderDataProps['type'],
    options: UseTestingPlaceholderDataOptions,
) => {
    const { course, test, isActiveTest, onStart } = options;

    const { t } = useTranslation(['common', 'testing']);

    const placeholder = React.useMemo(
        () =>
            getTestingCoursePlaceholderData(type, {
                t,
                course,
                test,
                isActiveTest,
                onStart,
            }),
        [t, type, test, course, isActiveTest, onStart],
    );

    return placeholder;
};

export { useTestingCoursePlaceholderData };
